<template>
  <v-card flat>
    <v-card-title>Actualizar precios</v-card-title>
    <v-card-text>
      <p class="mb-4">
        Los productos listados a continuación tienen precios de venta asociados
        a la empresa y a las sucursales.
        <strong>Puedes actualizar estos precios de manera conjunta.</strong>
      </p>

      <v-row justify="center">
        <v-col cols="12" md="12">
          <span class="text-h5"
            >{{ productoSeleccionado.descripcion_comercial }}
          </span>
        </v-col>
        <v-col cols="12" md="5">
          <v-card>
            <template #progress>
              <v-progress-linear
                color="deep-purple"
                height="10"
                indeterminate
              ></v-progress-linear>
            </template>

            <v-img
              height="250"
              src="require('@/assets/no-image.png')"
            ></v-img>

            <v-card-title>{{ productoSeleccionado.descripcion }}</v-card-title>
            <v-card-text>
              <div class="mt-4">
                <v-form v-model="formValido">
                  <v-subheader
                    >Datos generales del producto (catálogo)</v-subheader
                  >
                  <GenericAttributeInput
                    attributeName="precio_costo_base"
                    label="Precio de Costo"
                    type="number"
                    :rules="'required|decimal:2|max:30'"
                    :value="productoSeleccionado.precio_costo_base"
                    :outlined="true"
                    @update-attribute="
                      (payload) => handleAttributeUpdateBase(payload)
                    "
                  />
                  <GenericAttributeInput
                    attributeName="margen_ganancia_sugerido"
                    label="Margen de ganancia"
                    type="number"
                    :rules="'required|decimal:2|max:30'"
                    :value="productoSeleccionado.margen_ganancia_sugerido"
                    :outlined="true"
                    @update-attribute="
                      (payload) => handleAttributeUpdateBase(payload)
                    "
                  />

                  <PrecioVentaCalculatorWrapper
                    :precioCosto="productoSeleccionado.precio_costo_base"
                    :ganancia="productoSeleccionado.margen_ganancia_sugerido"
                    :precioVenta="productoSeleccionado.precio_venta_sugerido"
                    :esPrecioVentaManual="false"
                    :disabled="true"
                    tipoRedondeo="decimales"
                    :outlined="true"
                    ref="precioVentaWrapper"
                  />
                  <PrecioVentaCalculatorWrapper
                    :precioCosto="productoSeleccionado.precio_costo_base"
                    :ganancia="productoSeleccionado.margen_ganancia_sugerido"
                    :precioVenta="productoSeleccionado.precio_venta_sugerido"
                    :esPrecioVentaManual="true"
                    tipoRedondeo="entero"
                    :outlined="true"
                    @update:precioVenta="
                      handleAttributeUpdateBase({
                        name: 'precio_venta_sugerido',
                        value: $event,
                      })
                    "
                    @update:ganancia="
                      handleAttributeUpdateBase({
                        name: 'margen_ganancia_sugerido',
                        value: $event,
                      })
                    "
                    ref="precioVentaWrapper"
                  />
                </v-form>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                color="white"
                :disabled="!formValido"
                @click="validateForm"
              >
                Actualizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="7">
          <v-row v-if="productoSeleccionado && productoSeleccionado.sucursales_compartidas.length > 0">
            <v-col cols="12" md="12">
              <ProductosActualizarPreciosPorSucursal
                v-for="(
                  sucursal, index
                ) in productoSeleccionado.sucursales_compartidas"
                :key="index"
                :productoConSucursal="copiarSucursal(sucursal)"
                @actualizacionExitosa="$emit('actualizacionExitosa')"
              ></ProductosActualizarPreciosPorSucursal>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductosAPI from "@/api/productos";
import PrecioVentaCalculatorWrapper from "@/components/producto/form/PrecioVentaCalculatorWrapper.vue";
import GenericAttributeInput from "@/components/util/GenericAttributeInput.vue";
import ProductosActualizarPreciosPorSucursal from "@/components/producto/gestion/ProductosActualizarPreciosPorSucursal.vue";

export default {
  name: "ProductosActualizarPrecios",

  components: {
    GenericAttributeInput,
    PrecioVentaCalculatorWrapper,
    ProductosActualizarPreciosPorSucursal,
  },
  $_veeValidate: {
    validator: "new",
  },
  props: {
    productoSeleccionado: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formValido: false,

    
      productoNuevo: {
        descripcion: "",
        precio_venta_sugerido: null,
        sucursales_compartidas: [],
      },
    };
  },
 
  methods: {
    handleAttributeUpdateBase({ name, value }) {
        this.$set(this.productoSeleccionado, name, value); // Usar $set es una buena práctica si el atributo pudiera no existir inicialmente
      },
    validateForm() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.actualizarPrecios();
        } else {
          this.$validator.validate();
        }
      });
    },
    copiarSucursal(sucursal) {
      return JSON.parse(JSON.stringify(sucursal));
    },
    // Actualiza el precio de las sucursales cuando se cambia el precio de la empresa
    actualizarPreciosSucursales() {
      this.productoNuevo.sucursales_compartidas.forEach((sucursal) => {
        sucursal.precio_venta = this.productoNuevo.precio_venta_sugerido;
      });
    },

    // Enviar solicitud al API para actualizar los precios
    async actualizarPrecios() {
      try {
        const payload = {
          id: this.productoSeleccionado.id,
          precio_venta_sugerido: this.productoSeleccionado.precio_venta_sugerido,
          margen_ganancia_sugerido: this.productoSeleccionado.margen_ganancia_sugerido,
          precio_costo_base: this.productoSeleccionado.precio_costo_base,

          // sucursales: this.productoNuevo.sucursales_compartidas.map(
          //   (sucursal) => ({
          //     sucursal_id: sucursal.id,
          //     precio_venta: sucursal.precio_venta,
          //   })
          // ),
        };
        console.log(payload);
        

        const response = await ProductosAPI.updateProductoEmpresa(payload);

        // Emitir éxito al componente padre
        this.$emit("actualizacionExitosa", response.data);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Precios actualizados exitosamente",
          icon: "mdi-check",
          timeout: 3000,
        });
      } catch (error) {
        console.error(error);
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "error",
          text: `Error al actualizar precios: ${error.response.data.detail}`,
          icon: "mdi-alert-circle",
          timeout: 3000,
        });
      }
    },
  },
};
</script>
